interface FwConfig {
  apiUrl?: string;
}

const config: FwConfig = {};

export function useFw(newConfig: FwConfig) {
  Object.assign(config, newConfig);
}

export function useConfig(): FwConfig {
  return config;
}
